import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { CredentialsInterceptor } from "./credentials.interceptor";
import { BaseUrlInterceptor } from './base-url.interceptor';
import { AuthInterceptor } from './auth.interceptor';
import { ReportTimezoneInterceptor } from './report-timezone.interceptor';

/**
 * All http interceptors should be declared here
 */
export const httpInterceptorProviders = [
    { provide: HTTP_INTERCEPTORS, useClass: CredentialsInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: BaseUrlInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ReportTimezoneInterceptor, multi: true },
];
